/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_All_FeaturesInputs */

const en_footer_aria_all_features = /** @type {(inputs: Footer_Aria_All_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all features`)
};

const es_footer_aria_all_features = /** @type {(inputs: Footer_Aria_All_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las funciones`)
};

/**
* | output |
* | --- |
* | "View all features" |
*
* @param {Footer_Aria_All_FeaturesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_all_features = /** @type {((inputs?: Footer_Aria_All_FeaturesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_All_FeaturesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_all_features(inputs)
	return en_footer_aria_all_features(inputs)
});